import { useMemo } from "react";
import { validateCoords } from "~/lib/validate-coords";

export function useValidCoords(geometry?: GeoJSON.Geometry) {
  return useMemo(() => {
    if (!geometry) return [0, 0];
    if (geometry.type === "Point") {
      return validateCoords(...(geometry.coordinates as [number, number]));
    } else {
      return [0, 0];
    }
  }, [geometry]);
}
